<template>
  <v-card color="yellow lighten-4">
    <ODialog ref="dialog" hideWhenLoading :maxWidth="600">
      <v-card v-if="row != null">
        <ODialogBar title="Editar Comentários" @close="$refs.dialog.$dismiss" />
        <v-card-text class="pa-6">
          <v-textarea
            autofocus
            rows="5"
            label="Observações"
            v-model="row.comments"
            hide-details
            filled
          />

          <v-switch
            v-model="row.hasReminder"
            label="Destacar lembrete na aba Geral"
          />
        </v-card-text>

        <ODialogButtons
          class="pa-6"
          @cancel="$refs.dialog.$dismiss"
          @apply="save"
        />
      </v-card>
    </ODialog>

    <v-card-text class="pa-4">
      <v-btn icon class="absolute-btn" @click="startEdit">
        <v-icon>edit</v-icon>
      </v-btn>

      <p
        style="white-space: pre-wrap; min-height: 20px"
        v-text="client.comments"
      />
    </v-card-text>
  </v-card>
</template>

<script>
import { Client } from '@/models'

export default {
  props: {
    client: { required: true }
  },
  data() {
    return {
      row: null
    }
  },
  methods: {
    startEdit() {
      let { comments, hasReminder } = this.client
      this.row = { comments, hasReminder }
      this.$refs.dialog.$open()
    },

    async save() {
      await this.$refs.dialog.$loading(async () => {
        await Client.patch(this.client.id, {
          comments: this.row.comments,
          hasReminder: this.row.hasReminder
        })

        this.$refs.dialog.$dismiss()
      })

      this.$emit('reload')
    }
  }
}
</script>

<style>
.absolute-btn {
  float: right;
  /* right: 12px; */
}
</style>
